import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[85vh] md:h-[70vh] w-full overflow-hidden flex items-center justify-center py-16 md:py-0" data-id="element-242">
      {/* Background Image - Using a high-quality cultural aesthetic image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/vuzBhiNjRsRpwZsQH52rqj/pasted-image.png")',
      filter: 'brightness(0.7)'
    }} data-id="element-243" />

      <div className="relative z-10 text-center px-4" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="pb-12 md:pb-0" data-id="element-245">
          <h1 className="text-3xl md:text-7xl font-serif text-white mb-4 md:mb-6 tracking-tight leading-tight" data-id="element-246">
            ADORNED IN <br data-id="element-247" />
            <span className="text-gold italic" data-id="element-248">AFRICAN CULTURE</span>
          </h1>
          <p className="text-white text-sm md:text-lg font-light mb-6 md:mb-8 max-w-3xl mx-auto tracking-wide leading-relaxed px-4 md:px-0" data-id="element-249">
            Curated African clothing, jewelry, and accessories inspired by
            heritage, craftsmanship, and modern style.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 px-4 md:px-0" data-id="element-250">
            <Link to="/shop" className="w-full sm:w-auto" data-id="element-251">
              <button className="bg-white text-black px-8 md:px-10 py-3 md:py-4 text-[10px] md:text-xs uppercase tracking-widest hover:bg-black hover:text-white transition-all duration-300 w-full" data-id="element-252">
                Shop New Arrivals
              </button>
            </Link>
            <Link to="/product/gift-card" className="w-full sm:w-auto" data-id="element-253">
              <button className="bg-gold text-black px-8 md:px-10 py-3 md:py-4 text-[10px] md:text-xs uppercase tracking-widest font-bold hover:bg-white transition-all duration-300 w-full" data-id="element-254">
                Buy Gift Card
              </button>
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Bottom Border Accent - Mohini style */}
      <div className="absolute bottom-0 left-0 w-full h-1.5 md:h-2 flex" data-id="element-255">
        <div className="flex-1 bg-[#009246]" data-id="element-256"></div>
        <div className="flex-1 bg-[#F1EB33]" data-id="element-257"></div>
        <div className="flex-1 bg-[#CE1126]" data-id="element-258"></div>
      </div>
    </section>;
}